import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "agent-left" }
const _hoisted_2 = { class: "agent-left-top" }
const _hoisted_3 = { class: "agent-left-bottom" }
const _hoisted_4 = {
  key: 0,
  class: "agent-left-bottom-body my-scroller"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "agent-info" }
const _hoisted_7 = { class: "agent-name" }
const _hoisted_8 = {
  key: 0,
  class: "official"
}
const _hoisted_9 = { class: "projectName" }
const _hoisted_10 = { class: "description" }
const _hoisted_11 = {
  key: 0,
  class: "item-option"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

import { ref, computed } from 'vue';
import {
  appProjectAddProject,
  appProjectGetAppAppProjectPage,
  appProjectGetModelProvider,
  appProjectGetAppAppProject,
  appProjectUpdateProject,
  appProjectDeleteAppProject,
} from '@/request/appProject';

import detailInit from '@/views/superAgent/detailInit.json'


export default /*@__PURE__*/_defineComponent({
  __name: 'superAgentLeft',
  props: {
  active: Object
},
  emits: ['handleClick', 'update:active'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

// 获取智能体项目列表
let agentList = ref([]);
let agentParams = ref({ pageIndex: 1, pageSize: 50, keyword: '', total: null });
let appProjectGetAppAppProjectPageFn = (obj = agentParams.value) => {
  appProjectGetAppAppProjectPage(obj).then((res) => {
    let { data, code } = res.data
    if (code !== 200) return
    else {
      // 排序：将 systemDefault 为 true 的项目排在前面
      data.list.sort((a, b) => b.systemDefault - a.systemDefault);
      agentList.value = data.list;
      agentParams.value.total = data.total;

      // 默认选中 systemDefault 为 false 的最新项目
      let defaultItem = agentList.value?.find(item => !item.systemDefault);
      if (defaultItem && !active.value?.id) {
        handleClick('edit', defaultItem);
      }
    }
  });
};
// 获取项目列表
appProjectGetAppAppProjectPageFn();



// 操作
const emit = __emit;
const active = computed({
  get() {
    return props.active;
  },
  set(value) {
    emit('update:active', value);
  }
});
let handleClick = (type = 'add', row = detailInit) => {
  console.log('row', row);

  if (row.systemDefault) return
  emit('handleClick', type, row);
  if (type === 'del') {
    return
  }
  active.value = row
}

// 暴露方法
__expose({
  appProjectGetAppAppProjectPageFn, agentList, handleClick
});

return (_ctx: any,_cache: any) => {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "agent-btn-add",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleClick)('add', _unref(detailInit))))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("i", {
          class: "ri-add-circle-fill",
          style: {"margin-right":"5px"}
        }, null, -1),
        _createTextVNode("创建智能体 ")
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_divider, { style: {"margin-bottom":"0"} }),
      (_unref(agentList).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(agentList), (i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["agent-left-bottom-body-item", { 'selected': i.id === active.value.id }]),
                key: i,
                onClick: ($event: any) => (_unref(handleClick)('edit', i))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (i.systemDefault)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 官方 "))
                      : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createElementVNode("i", {
                      class: "ri-robot-line",
                      style: {"margin-right":"5px"}
                    }, null, -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(i.projectName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(i.description), 1)
                ]),
                (!i.systemDefault)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "edit-icon",
                        onClick: _withModifiers(($event: any) => (_unref(handleClick)('edit', i)), ["stop"])
                      }, _cache[3] || (_cache[3] = [
                        _createElementVNode("i", { class: "ri-edit-box-line" }, null, -1)
                      ]), 8, _hoisted_12),
                      _createElementVNode("div", {
                        class: "delete-icon",
                        onClick: _withModifiers(($event: any) => (_unref(handleClick)('del', i)), ["stop"])
                      }, _cache[4] || (_cache[4] = [
                        _createElementVNode("i", { class: "ri-delete-bin-line" }, null, -1)
                      ]), 8, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_5))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_el_empty, {
            key: 1,
            description: "暂无数据"
          }))
    ])
  ]))
}
}

})